import Image from "./Image";
export default function ApplicationLogo() {
    return (
        <Image className="main-image" src="/assets/logo_lh.png" title="Wish i was there with you" alt="site logo image" role="img" />
    );
}
